import { render, staticRenderFns } from "./people.vue?vue&type=template&id=3aa996db&scoped=true&"
import script from "./people.vue?vue&type=script&lang=js&"
export * from "./people.vue?vue&type=script&lang=js&"
import style0 from "./people.vue?vue&type=style&index=0&id=3aa996db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa996db",
  null
  
)

export default component.exports